// features/notifications/panels/ActivityOverviewPanel.tsx — right-rail activity counts.

import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import type { Notification } from '@/core/models/notification';
import { activityCounts } from '../filterNotifications';

export interface ActivityOverviewPanelProps {
  notifications: Notification[];
}

const RowEl = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Value = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.color.textMuted};
`;

export function ActivityOverviewPanel({ notifications }: ActivityOverviewPanelProps) {
  const c = activityCounts(notifications);
  const rows: { label: string; value: number }[] = [
    { label: 'Cherishes',     value: c.likes },
    { label: 'Replies',       value: c.replies },
    { label: 'Mentions',      value: c.mentions },
    { label: 'New Followers', value: c.followers },
  ];
  return (
    <Panel>
      <SectionLabel as="h2">Activity Overview</SectionLabel>
      {rows.map((r) => (
        <RowEl key={r.label}>
          <span>{r.label}</span>
          <Value>{r.value}</Value>
        </RowEl>
      ))}
    </Panel>
  );
}
